import { Component, OnInit, NgZone, ApplicationRef } from '@angular/core';
import { BillingService } from '../../core/billing.service';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.less']
})
export class BillingComponent {
  show: boolean = false;

  constructor(
    public ngZone: NgZone,
    public appref: ApplicationRef,
    public billingService: BillingService
  ) {}

  getShow() {
    return this.show = this.billingService.getShow();
  }

  showBilling() {
    this.show = true;
  }

  hideBilling() {
    this.show = false;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/billing/billing.component.ts